(function ($) {
	'use strict';

	var WEAPP = {

		init: function () {
			this.mainMenuBlock();
			this.mainMenuBlock1();
			this.submenuOpener();
			this.fixedHeader();
			this.headerSearch();
			this.submenuOpenerFooter();
			this.heroSlider();
			this.serviceSlider();
			this.newsSlider();
			this.gallerySlider();
			this.verticalSlider();
			this.verticalSlider1();
			this.eqHeightDiv();


		},



		mainMenuBlock: function () {
			jQuery('header').on('click', '.navbar-toggle-btn', function (e) {
				e.preventDefault();
				if (!jQuery(this).hasClass("nav-open")) {
					jQuery('#navbar').removeClass('active');
					jQuery('html').removeClass('menu-active');
					jQuery(this).removeClass('nav-close').addClass('nav-open');

				} else {
					jQuery('#navbar').addClass('active');
					jQuery('html').addClass('menu-active');
					jQuery(this).removeClass('nav-open').addClass('nav-close');
				}
			});
		},

		mainMenuBlock1: function () {
			jQuery('header').on('click', '.navbar-toggle-btn.nav-close', function (e) {
				jQuery('html').removeClass('submenu-active');
				jQuery('.nav-item').removeClass('opened');
				jQuery('.submenu-opener').removeClass('closed');
				jQuery('.dropdown-menu').css("display", "none");
			});
		},

		submenuOpener: function () {
			jQuery("header.main-header .navbar-nav .submenu-opener").on('click', function (e) {
				// e.preventDefault();
				jQuery('html').toggleClass('submenu-active');

				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).parent('.nav-item').addClass('opened');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).parent('.nav-item').removeClass('opened');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},



		fixedHeader: function () {
			jQuery(window).scroll(function () {
				var sticky = jQuery('header'),
					scroll = jQuery(window).scrollTop();

				if (scroll >= 30) sticky.addClass('sticky-header');
				else sticky.removeClass('sticky-header');
			});
		},

		headerSearch: function () {
			jQuery(".search-icon-block").on('click', function (e) {
				// e.preventDefault();
				jQuery('.search-input-wrapper').slideToggle();

			});

		},

		submenuOpenerFooter: function () {
			jQuery(".footer-menu-block-sm .submenu-opener").on('click', function (e) {
				// e.preventDefault();


				if (!jQuery(this).hasClass('closed')) {
					jQuery(this).addClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}
				else {
					jQuery(this).removeClass('closed');
					jQuery(this).next('ul.dropdown-menu').slideToggle();
				}

			});

		},

	


		heroSlider: function () {
			var $mainslider = $('.hero-slider')


			// Slick Slider Options
			$mainslider.slick({
				draggable: true,
				arrows: true,
				dots: false,
				fade: true,
				infinite: true,
				speed: 300,
				mobileFirst: true,
				pauseOnHover: true,
			});

			// Slider Progressbar Start Here
			var time = 10;
			var $bar,
				$mainslider,
				isPause,
				tick,
				percentTime;

			$bar = $('.slider-progress .progress');

			function startProgressbar() {
				resetProgressbar();
				percentTime = 0;
				isPause = false;
				tick = setInterval(interval, 15);
			}

			function interval() {
				if (isPause === false) {
					percentTime += 1 / (time + 0.1);
					$bar.css({
						width: percentTime + "%"
					});
					if (percentTime >= 100) {
						$mainslider.slick('slickNext');
					}
				}
			}
			function resetProgressbar() {
				$bar.css({
					width: 0 + '%'
				});
				clearTimeout(tick);
			}
			// Reset Progressbar When Slide Change
			$mainslider.on('afterChange', function (event, slick, currentSlide) {
				startProgressbar();
			});

			$('.hero-block').on({
				mouseenter: function () {
					isPause = true;
				},
				mouseleave: function () {
					isPause = false;
				}
			})
			startProgressbar();

		},

		serviceSlider: function () {
			var $serviceslider = $('.service-slider-block')


			// Slick Slider Options
			$serviceslider.slick({
				draggable: true,
				arrows: true,
				dots: false,
				fade: true,
				infinite: true,
				speed: 300,
				mobileFirst: true,
				pauseOnHover: true,
			});

			// Slider Progressbar Start Here
			var time = 10;
			var $bar,
				$serviceslider,
				isPause,
				tick,
				percentTime;

			$bar = $('.slider-progress1 .progress1');

			function startProgressbar() {
				resetProgressbar();
				percentTime = 0;
				isPause = false;
				tick = setInterval(interval, 15);
			}

			function interval() {
				if (isPause === false) {
					percentTime += 1 / (time + 0.1);
					$bar.css({
						width: percentTime + "%"
					});
					if (percentTime >= 100) {
						$serviceslider.slick('slickNext');
					}
				}
			}
			function resetProgressbar() {
				$bar.css({
					width: 0 + '%'
				});
				clearTimeout(tick);
			}
			// Reset Progressbar When Slide Change
			$serviceslider.on('afterChange', function (event, slick, currentSlide) {
				startProgressbar();
			});

			$('.service-slider-block').on({
				mouseenter: function () {
					isPause = true;
				},
				mouseleave: function () {
					isPause = false;
				}
			})
			startProgressbar();

		},



		newsSlider: function () {
			$('.news-slider-row').slick({
				dots: false,
				infinite: false,
				speed: 1000,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				autoplay: false,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 3.2,
						}
					},
					{
						breakpoint: 991,
						settings: {
							slidesToShow: 2.2,
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1.2,
						}
					},
				]
			});
		},




		gallerySlider: function () {
			function updSwiperNumericPagination() {
				this.el.querySelector(".swiper-counter").innerHTML = '<span class="count">' + (this.realIndex + 1) + '</span>/<span class="total">' + this.el.slidesQuantity + "</span>";
			}
			$(".slider").each(function () {
				// Getting slides quantity before slider clones them
				this.slidesQuantity = this.querySelectorAll(".swiper-slide").length;

			});
			var sliderThumbnail = new Swiper('.slider-thumbnail', {
				slidesPerView: 5,
				slidesPerColumn: 2,
				spaceBetween: 20,
				watchSlidesProgress: true,

				navigation: {
					nextEl: '.swiper-button-next1',
					prevEl: '.swiper-button-prev1',
				},
				breakpoints: {
					// when window width is <= 767px
					767: {
						slidesPerView: 3,
						slidesPerColumn: 1,
						spaceBetween: 10,

					},
					991: {
						slidesPerView: 4,
						slidesPerColumn: 1,

					},
					1199: {
						slidesPerView: 4,
						slidesPerColumn: 2,

					},
				}
			});

			//スライダー
			var slider = new Swiper('.slider', {
				// effect: 'fade',
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				thumbs: {
					swiper: sliderThumbnail
				},

				on: {
					init: updSwiperNumericPagination,
					slideChange: updSwiperNumericPagination
				}
			});


		},

		verticalSlider: function () {
			var $status = $('.pagingInfo1');
			var $slickElement = $('.boat-ad-slider');

			$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
				//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
				var i = (currentSlide ? currentSlide : 0) + 1;
				$status.text(i + ' / ' + slick.slideCount);
			});

			const $slider = $(".boat-ad-slider");
			$slider
				.on('init', () => {
					mouseWheel($slider)
				})
				.slick({
					dots: false,
					vertical: true,
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					responsive: [
						
						{
							breakpoint: 991,
							settings: {
								arrows: true,
							}
						}, 
						{
							breakpoint: 767,
							settings: {
								slidesToShow: 2,
								arrows: true,
							}
						},
					]
				})
			function mouseWheel($slider) {
				$(window).on('wheel', { $slider: $slider }, mouseWheelHandler)
			}
			function mouseWheelHandler(event) {
				event.preventDefault()
				const $slider = event.data.$slider
				const delta = event.originalEvent.deltaY
				if (delta > 0) {
					$slider.slick('slickNext')
				}
				else {
					$slider.slick('slickPrev')
				}
			}

			

		},

		verticalSlider1: function () {
			var swiper = new Swiper('.swiper-containers', {
				pagination: '.swiper-pagination',
				direction: 'vertical',
				slidesPerView: 1,
				paginationClickable: true,
				spaceBetween: 0,
				mousewheelControl: true,
				speed: 100
		 });
			
			

		},


		eqHeightDiv: function () {
			var title = 0;
			jQuery(".img-text-container-wrapper-alt .img-wrapper ").each(function () {
				if ($(this).height() > title) { title = $(this).height(); }
			});
			jQuery(".img-text-container-wrapper-alt .img-wrapper ").height(title);


			//on Resize change height

			jQuery(window).resize(function () {
				jQuery(".img-text-container-wrapper-alt .img-wrapper ").height("");
				var title = 0;
				jQuery(".img-text-container-wrapper-alt .img-wrapper ").each(function () {
					if ($(this).height() > title) { title = $(this).height(); }
				});
				jQuery(".img-text-container-wrapper-alt .img-wrapper ").height(title);
			});

			

		},




	};

	WEAPP.init();

})(jQuery);



